import { render, staticRenderFns } from "./workerCertificate.vue?vue&type=template&id=443aa026&"
import script from "./workerCertificate.vue?vue&type=script&lang=js&"
export * from "./workerCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports